// extracted by mini-css-extract-plugin
module.exports = {"side-menu":"SideMenu_side-menu__wZY6x"};